export default __webpack_public_path__ + "static/media/Code-typing-bro.8a639656.svg";